module.exports = __webpack_public_path__ + "img/lose_lottery3_mall.7de2a070.png";